<template>
    <div>
        <div class="pilots-requirements-container">
            <div class="pilots-requirements">
                <div class="image">
                    <img :src="$t('registration.pilots.travel-tailor-made-img')" />
                </div>
                <div class="content">
                    <div class="content-box flex">
                        <h2>1</h2>
                        <p>{{ $t('registration.pilots.travel-tailor-made.desc-1') }}</p>
                    </div>
                    <div class="content-box flex">
                        <h2>2</h2>
                        <p>{{ $t('registration.pilots.travel-tailor-made.desc-2') }}</p>
                    </div>
                    <div class="content-box flex">
                        <h2>3</h2>
                        <p>{{ $t('registration.pilots.travel-tailor-made.desc-3') }}</p>
                    </div>
                    <div class="content-box flex">
                        <h2>4</h2>
                        <p>{{ $t('registration.pilots.travel-tailor-made.desc-4') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="pilots-insurance-container">
            <div class="pilots-insurance">
                <div class="image">
                    <img :src="$t('registration.pilots.pilot-insurance.pilot-insurance-img')" />
                </div>
                <div class="pilots-insurance-text">
                    <div class="pilots-insurance-title">{{ $t('registration.pilots.pilot-insurance.title') }}</div>
                    <div class="pilots-insurance-description">{{ $t('registration.pilots.pilot-insurance.description') }}</div>
                </div>
            </div>
            <div class="pilots-insurance-button">
                <a class="md-button md-raised md-primary md-theme-default" :href="$t('rewriting.pilot-insurance')+'.html'" style="font-weight: bold;">
                    <div class="md-ripple md-disabled">
                        <div class="md-button-content">
                            {{ $t('registration.pilots.pilot-insurance.pilot-insurance-button') }}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            largeScreen: document.documentElement.clientWidth >= 768
        };
    }
};
</script>
<style lang="scss" scoped>
@import "~styles/_variables";
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PilotsRequirements.vue